<template>
  <div>
    <el-form
      label-position="top"
      :model="compcase"
      :rules="rules"
      ref="compcase"
      class="compcase-form"
    >
      <h4>Case Details</h4>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item prop="type">
            <select
              v-model="compcase.type"
              placeholder="Select Type"
              :class="
                compcase.type !== undefined
                  ? 'tw-font-medium tw-text-black'
                  : 'tw-font-normal tw-text-black'
              "
            >
              <option disabled :value="undefined" selected>Select Type</option>
              <option
                v-for="{ type, name } in compCasesTypes"
                :label="name"
                :key="type"
                :value="type"
              >
                {{ name }}
              </option>
            </select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item prop="scene">
            <select
              v-model="compcase.scene"
              placeholder="Select Scene"
              :class="
                compcase.scene !== undefined
                  ? 'tw-font-medium tw-text-black'
                  : 'tw-font-normal tw-text-black'
              "
            >
              <option disabled :value="undefined" selected>Select Scene</option>
              <option v-for="{ type, name } in sceneType" :label="name" :key="type" :value="type">
                {{ name }}
              </option>
            </select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item prop="meta.competition._id">
            <select
              v-model="compcase.meta.competition._id"
              placeholder="Select Competition"
              :class="
                compcase.meta.competition._id !== undefined
                  ? 'tw-font-medium tw-text-black'
                  : 'tw-font-normal tw-text-black'
              "
            >
              <option disabled :value="undefined" selected>Select Competition</option>
              <option v-for="{ _id, name } in competitions" :label="name" :key="_id" :value="_id">
                {{ name }}
              </option>
            </select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item prop="round">
            <select
              value-key="displayName"
              placeholder="Select Round"
              v-model="round"
              :disabled="compcase.scene === 2"
              :class="
                round !== undefined
                  ? 'tw-font-medium tw-text-black'
                  : 'tw-font-normal tw-text-black'
              "
            >
              <option disabled :value="undefined" selected>Select Round</option>
              <option
                v-for="item in rounds"
                :label="item.displayName"
                :key="item.displayName"
                :value="item"
              >
                {{ item.displayName }}
              </option>
            </select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item prop="meta.matchId">
            <select
              v-model="compcase.meta.matchId"
              placeholder="Select Match"
              :disabled="compcase.scene === 2"
              :class="
                compcase.meta.matchId !== undefined
                  ? 'tw-font-medium tw-text-black'
                  : 'tw-font-normal tw-text-black'
              "
            >
              <option disabled :value="undefined" selected>Select Match</option>
              <option
                v-for="{ _id, homeTeam, awayTeam, meta } in filteredMatches"
                :label="
                  `${(homeTeam && homeTeam.name) || (meta.isBye ? 'BYE' : 'NA')} vs ${(awayTeam &&
                    awayTeam.name) ||
                    (meta.isBye ? 'BYE' : 'NA')}`
                "
                :key="_id"
                :value="_id"
              >
                {{
                  `${(homeTeam && homeTeam.name) || (meta.isBye ? "BYE" : "NA")} vs ${(awayTeam &&
                    awayTeam.name) ||
                    (meta.isBye ? "BYE" : "NA")}`
                }}
              </option>
            </select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item prop="meta.teamId">
            <select
              v-model="compcase.meta.teamId"
              placeholder="Select Team"
              :disabled="clearance === roles.teamAdmin"
              :class="
                compcase.meta.teamId !== undefined
                  ? 'tw-font-medium tw-text-black'
                  : 'tw-font-normal tw-text-black'
              "
            >
              <option disabled :value="undefined" selected>Select Team</option>
              <option v-for="{ _id, name } in teams" :label="name" :key="_id + 'team'" :value="_id">
                {{ name }}
              </option>
            </select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item prop="memberId">
            <select
              v-model="compcase.memberId"
              placeholder="Select Member"
              :class="
                compcase.memberId !== undefined
                  ? 'tw-font-medium tw-text-black'
                  : 'tw-font-normal tw-text-black'
              "
            >
              <option disabled :value="undefined" selected>Select Member</option>
              <option
                v-for="item in members"
                :label="nameFormatter(item)"
                :key="item._id"
                :value="item._id"
              >
                {{ nameFormatter(item) }}
              </option>
            </select>
          </el-form-item>
        </el-col>
      </el-row>
      <hr />
      <h4 class="tw-mt-2.5">Charges</h4>
      <el-form
        label-position="top"
        :model="charge"
        :rules="chargeRules"
        ref="charge"
        class="charge-form"
      >
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item prop="id">
              <select
                v-model="charge.id"
                placeholder="Select Charge"
                clearable
                filterable
                :class="
                  charge.id !== undefined
                    ? 'tw-font-medium tw-text-black'
                    : 'tw-font-normal tw-text-black'
                "
              >
                <option disabled :value="undefined" selected>Select Charge</option>
                <option
                  v-for="{ type, name } in caseCharges"
                  :label="name"
                  :key="type"
                  :value="type"
                >
                  {{ name }}
                </option>
              </select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item prop="description">
              <input
                class="input"
                autocomplete="off"
                placeholder="Description"
                v-model="charge.description"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item prop="recommendedGrading">
              <select
                v-model="charge.recommendedGrading"
                placeholder="Recommended Grading"
                :class="
                  charge.recommendedGrading !== undefined
                    ? 'tw-font-medium tw-text-black'
                    : 'tw-font-normal tw-text-black'
                "
              >
                <option disabled :value="undefined" selected>Recommended Grading</option>
                <option v-for="item in chargeGradings" :label="item" :key="item" :value="item">
                  {{ item }}
                </option>
              </select>
            </el-form-item>
          </el-col>

          <button class="btn-success" type="success" @click="addCharge">Add</button>
        </el-row>
      </el-form>
      <el-row :gutter="10" class="mb-2">
        <el-col>
          <data-tables
            :data="compcase.charges"
            :table-props="{ border: true }"
            layout="table"
            class="data-table"
          >
            <el-table-column label="Type" prop="name" width="300"> </el-table-column>
            <el-table-column label="Description" prop="description" width="300"> </el-table-column>
            <el-table-column label="Recommended Grading" prop="recommendedGrading" width="200">
            </el-table-column>
            <el-table-column width="200">
              <template slot-scope="scope">
                <el-button type="danger" @click="removeCharge(scope.$index)">Delete</el-button>
              </template>
            </el-table-column>
          </data-tables>
        </el-col>
      </el-row>
      <hr />
      <h4>Notes</h4>
      <el-row>
        <el-col :span="24">
          <el-form-item prop="note" label="Notes">
            <textarea class="textBox" resize="none" rows="4" v-model="compcase.note"></textarea>
          </el-form-item>
        </el-col>
      </el-row>

      <button class="btn-cancel tw-mr-2.5 tw-mb-4" type="" size="medium" @click="cancel">
        Cancel
      </button>

      <button class="btn-success" type="success" size="`medium" @click="addCompcase">
        Submit
      </button>
    </el-form>
  </div>
</template>
<script>
import _ from "lodash";
import { roles, errormsg, caseCharges, compCasesTypes } from "../../utils/constants";

export default {
  components: {},
  data() {
    return {
      roles,
      caseCharges,
      tribunalStatus: ["Pending", "Charge Issued", "No Further Action Required"],
      compCasesTypes,
      sceneType: [
        { type: 1, name: "Match" },
        { type: 2, name: "Other" }
      ],
      chargeGradings: [1, 2, 3, 4, 5],
      competitions: [],
      competition: undefined,
      round: undefined,
      matches: [],
      members: [],
      charge: {
        id: undefined,
        name: "",
        description: undefined,
        recommendedGrading: undefined
      },
      chargeRules: {
        id: {
          required: true,
          message: errormsg.select_option,
          trigger: "blur"
        },
        description: {
          required: true,
          message: errormsg.input_option,
          trigger: "blur"
        },
        recommendedGrading: {
          required: true,
          message: errormsg.select_option,
          trigger: "blur"
        }
      },
      compcase: {
        type: 1, // const casesType = [ 1 = 'Tribunal', 2 = 'Injury' ]
        scene: 1, // const sceneType = [ 1 = 'Match', 2 = 'Other' ]
        memberId: undefined,
        charges: [], // [ PositiveInt ] ==> const charges = [ { id, name, description, recommendedGrading, grading, outcome } ]
        note: "",
        status: "Pending",
        meta: {
          competition: {
            _id: undefined,
            name: undefined
          },
          matchId: undefined,
          teamId: undefined,
          appeal: {}, // { lodged: Boolean, dateTime: Timestamp, outcome: String },
          penalty: {}, // type: String, units: PositiveInt, startDate: Timestamp, expiryDate: Timestamp
          suspendedPenalty: {} // { type: String, units: PositiveInt, expiryDate: Timestamp }
        }
      },
      rules: {
        type: {
          required: true,
          message: errormsg.input_option,
          trigger: "blur"
        },
        scene: {
          required: true,
          message: errormsg.input_option,
          trigger: "blur"
        },
        memberId: {
          required: true,
          message: errormsg.input_option,
          trigger: "blur"
        },
        "meta.competition._id": {
          required: true,
          message: errormsg.select_option,
          trigger: "blur"
        },
        "meta.matchId": {
          required: true,
          message: errormsg.input_option,
          trigger: "blur",
          validator: (rule, value, callback) => {
            if (this.compcase.scene === 1 && !value)
              return callback(new Error(errormsg.input_option));
            return callback();
          }
        },
        "meta.teamId": {
          required: true,
          message: errormsg.input_option,
          trigger: "blur"
        }
      }
    };
  },
  computed: {
    rounds() {
      if (this.matches && this.matches.length) {
        return _.chain(this.matches)
          .map("round")
          .orderBy(["type", "number"], ["desc", "asc"])
          .sortedUniqBy("displayName")
          .value();
      }
      return [];
    },
    filteredMatches() {
      if (this.matches && this.matches.length && this.round) {
        return this.matches.filter(
          x => x.round.type === this.round.type && x.round.number === this.round.number
        );
      }
      return this.matches;
    },
    teams() {
      let rs = [];
      if (this.compcase.scene === 1 && this.compcase.meta.matchId) {
        const match = this.matches.find(x => x._id === this.compcase.meta.matchId);
        if (match.homeTeam) rs.push(match.homeTeam);
        if (match.awayTeam) rs.push(match.awayTeam);
      }
      const competition = this.competitions.find(x => x._id === this.compcase.meta.competition._id);
      if (this.compcase.scene === 2 && competition && competition.teams.length) {
        rs = competition.teams;
      }
      return rs;
    },
    clearance() {
      return this.$store.getters["user/activeRole"].type;
    }
  },
  mounted() {
    if (this.clearance === roles.teamAdmin) {
      this.compcase.meta.teamId = this.$store.getters["user/activeRole"].entity._id;
    } else {
      this.compcase.meta.teamId = undefined;
    }

    this.$store.commit("root/loading", true);
    this.$http
      .get("/nrl/api/v1/admin/competition-cases/competitions")
      .then(res => {
        this.competitions = res.data.data;
        this.$store.commit("root/loading", false);
      })
      .catch(() => {
        this.$store.commit("root/loading", false);
        this.$customError();
      });
  },
  methods: {
    cancel() {
      this.$router.push({
        name: "competition-cases"
      });
    },
    nameFormatter(item) {
      if (item.profile)
        return `${_.get(item, "profile.firstName")} ${_.get(item, "profile.lastName")}`;
      return `${_.get(item, "firstName")} ${_.get(item, "lastName")}`;
    },
    getMembers() {
      this.members = [];
      if (this.compcase.scene === 1 && this.compcase.meta.teamId && this.compcase.meta.matchId) {
        this.$store.commit("root/loading", true);
        this.$http
          .get(
            `/nrl/api/v1/admin/teamlists/teams/${this.compcase.meta.teamId}/matches/${this.compcase.meta.matchId}`
          )
          .then(res => {
            const teamlist = res.data.data[0];
            if (teamlist && teamlist.players) {
              this.members = this.members.concat(teamlist.players);
            }
            if (teamlist && teamlist.nonplayers) {
              this.members = this.members.concat(teamlist.nonplayers);
            }
            this.$store.commit("root/loading", false);
          })
          .catch(err => {
            this.$store.commit("root/loading", false);
            this.$customError();
          });
      } else if (this.compcase.scene === 2 && this.compcase.meta.teamId) {
        this.$store.commit("root/loading", true);
        Promise.all([
          this.$http.get(`/nrl/api/v1/admin/squad/players/${this.compcase.meta.teamId}`),
          this.$http.get(`/nrl/api/v1/admin/squad/nonplayers/${this.compcase.meta.teamId}`)
        ])
          .then(([playersRes, nonplayersRes]) => {
            const playersBody = playersRes.data.data;
            const nonplayersBody = nonplayersRes.data.data;
            if (playersBody && playersBody.players) {
              this.members = this.members.concat(playersBody.players);
            }
            if (nonplayersBody && nonplayersBody.nonplayers) {
              this.members = this.members.concat(nonplayersBody.nonplayers);
            }
            this.$store.commit("root/loading", false);
          })
          .catch(err => {
            this.$store.commit("root/loading", false);
            this.$customError();
          });
      }
    },
    addCharge() {
      this.$refs.charge.validate(val => {
        if (val) {
          const charge = _.clone(this.charge);
          this.compcase.charges.push(charge);
          this.$refs.charge.resetFields();
          this.$refs.charge.clearValidate();
        }
      });
    },
    removeCharge(index) {
      this.compcase.charges.splice(index, 1);
    },
    addCompcase() {
      this.$refs.compcase.validate(val => {
        if (val) {
          if (!this.compcase.charges.length) {
            this.$customError(errormsg.no_charge);
            return;
          }
          this.$store.commit("root/loading", true);
          this.$http
            .post("/nrl/api/v1/admin/competition-cases", this.compcase)
            .then(res => {
              this.$refs.compcase.resetFields();
              this.$refs.compcase.clearValidate();
              this.$customSuccess();
              this.$store.commit("root/loading", false);
              if (res && res.data.data) {
                this.$router.push({
                  name: "competition-cases",
                  params: {
                    id: res.data.data
                  }
                });
              } else {
                this.$router.push({
                  name: "competition-cases"
                });
              }
            })
            .catch(() => {
              this.$store.commit("root/loading", false);
              this.$customError();
            });
        }
      });
    },
    resetFields() {
      this.round = undefined;
      this.compcase.meta.matchId = undefined;
      this.compcase.meta.teamId = undefined;
      this.compcase.memberId = undefined;
    }
  },
  watch: {
    "compcase.scene": function() {
      this.resetFields();
      // if user selected competition
      if (this.compcase.meta.competition._id && this.clearance === roles.teamAdmin) {
        this.compcase.meta.teamId = this.$store.getters["user/activeRole"].entity._id;
      }
    },
    "charge.id": function() {
      if (this.charge.id)
        this.charge.name = this.caseCharges.find(x => x.type === this.charge.id).name;
    },
    "compcase.meta.competition._id": function() {
      this.resetFields();
      this.matches = [];
      // get matches
      this.$store.commit("root/loading", true);
      if (this.compcase.meta.competition._id) {
        this.$http
          .get(
            `/nrl/api/v1/admin/competition-cases/competitions/${this.compcase.meta.competition._id}/matches`
          )
          .then(res => {
            this.matches = res.data.data;

            if (this.clearance === roles.teamAdmin) {
              this.compcase.meta.teamId = this.$store.getters["user/activeRole"].entity._id;
            }
            this.$store.commit("root/loading", false);
          })
          .catch(() => {
            this.$store.commit("root/loading", false);
            this.$customError();
          });
        // fill name of competition in meta.competition
        this.compcase.meta.competition.name = this.competitions.find(
          x => x._id === this.compcase.meta.competition._id
        ).name;
      }
    },
    round() {
      this.compcase.meta.matchId = undefined;
    },
    "compcase.meta.matchId": function() {
      if (this.clearance === roles.teamAdmin) {
        this.compcase.meta.teamId = this.$store.getters["user/activeRole"].entity._id;
      } else {
        this.compcase.meta.teamId = undefined;
      }
      this.compcase.memberId = undefined;
      this.getMembers();
    },
    "compcase.meta.teamId": function() {
      this.compcase.memberId = undefined;
      this.getMembers();
    }
  }
};
</script>
<style lang="scss" scoped>
.btn-control {
  text-align: right;
}
.el-input,
.el-select {
  width: 100%;
}
::v-deep .el-input {
  .el-input__inner {
    font-size: 16px;
  }
}

select {
  appearance: none; /* Remove default arrow */
  background-image: url("../../assets/chevron_down.svg"); /* Add custom arrow */
  background-position: center right;
  background-repeat: no-repeat;
  background-size: 40px 40px;
  background-position-y: 8px;
  @apply tw-w-full tw-px-2 tw-text-sm tw-placeholder-gray-800 focus:tw-outline-none tw-text-black tw-bg-transparent tw-border-b-2 tw-border-gray-200 tw-appearance-none tw-h-9;
}
.input {
  @apply tw-w-full tw-px-2 tw-text-sm tw-text-black tw-placeholder-gray-800 tw-bg-transparent tw-border-b-2 tw-border-gray-200 tw-shadow-none focus:tw-outline-none tw-h-9;
}

.textBox {
  @apply tw-w-full tw-px-2 tw-text-sm tw-text-black tw-placeholder-gray-800 tw-bg-transparent tw-border tw-border-gray-200 tw-shadow-none focus:tw-outline-none tw-h-9;
}

.btn-success {
  @apply tw-justify-center tw-w-full tw-h-10 tw-rounded-lg tw-text-sm tw-not-italic tw-font-medium  tw-capitalize tw-leading-11px tw-tracking-normal tw-text-center tw-text-white  tw-bg-green-700  tw-mb-9 hover:tw-bg-green-300 hover:tw-text-black sm:tw-w-64;
}
.btn-cancel {
  @apply tw-justify-center tw-w-full tw-h-10 tw-rounded-lg tw-text-sm tw-not-italic tw-font-medium  tw-capitalize tw-leading-11px tw-tracking-normal tw-text-center tw-text-black  tw-bg-gray-200 tw-border-2 tw-border-green-700  hover:tw-border-gray-200 sm:tw-w-64;
}
</style>
